import { Pin } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TweetPinnedBadgeProperties {
  className?: string;
}

export function TweetPinnedBadge({ className }: TweetPinnedBadgeProperties) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide text-warning',
        className
      )}
    >
      <Pin className="h-3.5 w-3.5" aria-hidden="true" />
      <span>Pinned Tweet</span>
    </div>
  );
}
